module.exports = __webpack_public_path__ + "img/user102.56e0c2b3.jpg";